import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-773341da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dynamicsContainer main_container" }
const _hoisted_2 = { class: "section2" }
const _hoisted_3 = { class: "news" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title news-title" }, "新闻", -1))
const _hoisted_5 = { class: "newsContainer" }
const _hoisted_6 = { class: "pic" }
const _hoisted_7 = ["data-src"]
const _hoisted_8 = { class: "text" }
const _hoisted_9 = { class: "news-content" }
const _hoisted_10 = { class: "info" }
const _hoisted_11 = { class: "section3" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "公司奖项", -1))
const _hoisted_13 = { class: "grid-container" }
const _hoisted_14 = { class: "content" }
const _hoisted_15 = {
  class: "image",
  alt: "item.content"
}
const _hoisted_16 = { class: "service_name" }
const _hoisted_17 = { class: "section4" }
const _hoisted_18 = { class: "core-force" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "芯力量", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subtitle desc force-desc" }, " 2022年7月15日16日，第六届集微半导体峰会在厦门国际会议中心酒店盛大开幕，本届峰会以「裂变，从混沌到有序」为主题，由中国半导体投资联盟、手机中国联盟主办，爱集微、厦门半导体投资集团承办。 作为峰会的一大亮点，首届中国半导体投资联盟会员大会暨第四届「芯力量」项目评选大赛决赛以及奖项揭晓的颁奖活动，吸引了与会嘉宾的极大关注。 「芯力量」项目评选决赛之后，40 位国内顶级投资人组成的评委会经过审议，投票选出 13 个「最具投资价值奖」企业，另外，还有 6 家企业获得了「投资机构推荐奖」。主题峰会上，国家集成电路产业投资基金股份有限公司总裁为获奖者颁奖。 南京元感微电子有限公司荣获「最具投资价值奖」。 ", -1))
const _hoisted_21 = { class: "container" }
const _hoisted_22 = { class: "content" }
const _hoisted_23 = {
  class: "image",
  alt: "元感微获奖照片"
}
const _hoisted_24 = { class: "service_name" }

import { ref, reactive, onMounted, onUnmounted } from "vue";
import QrCode from "@/components/QrCode.vue";
import Footer from "@/components/Footer.vue";
import { listNews } from "@/api/product";

// 获取环境变量
interface AwardImage {
  imgSrc: string;
  content: string;
  index?: number;
}

interface BottomImage {
  imgSrc: string;
  content: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'dynamics',
  setup(__props) {

const apiUrl = process.env.VUE_APP_API_URL;

// 获奖接口
let awardImgs = reactive<AwardImage[]>([
  // 访问本地的图片一定要加require
  {
    // imgSrc: require("@/assets/images/award1.png"),
    imgSrc: require("@/assets/images/award1.jpg"), // jpg比png更小，png是无损压缩
    content: "江苏省2020年青年双创大赛",
    index: 0,
  },
  {
    imgSrc: require("@/assets/images/award2.jpg"),
    content: "秦淮硅巷国际创新创业大赛",
    index: 1,
  },
  {
    imgSrc: require("@/assets/images/award3.jpg"),
    content: "江北新区高层次创业人才引进",
    index: 2,
  },
]);

let bottomImg = reactive<BottomImage[]>([
  {
    imgSrc: require("@/assets/images/xin1-01.jpg"),
    content: "最具投资价值奖",
  },
  {
    imgSrc: require("@/assets/images/xin1-02.jpg"),
    // imgSrc: require("@/assets/images/xin1.png"),
    content: "最具投资价值奖",
  },
]);

const showQRCode = ref<boolean>(true); // 控制二维码的显示与隐藏，默认是展示二维码。这个页面的几屏都显示二维码
const showFooter = ref<boolean>(true); // 控制底部Footer的显隐

// 观察一个元素     页面的最后一屏展示底部Footer
onMounted(() => {
  const options = {
    root: null, // oot表示观察器的根元素，默认为null，表示整个视窗。
    rootMargin: "0px", // rootMargin表示根元素的边界,设置为"0px"，表示边界与视窗边缘重合。
    threshold: 0.5, // 当目标元素50%可见时执行回调
  };

  const observerIsFooter = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.target.classList.contains("section4")) {
        showFooter.value = entry.isIntersecting; // 第三屏 section3 显示底部Footer
      }
    });
  }, options);

  const section4 = document.querySelector(".section4"); // 获取元素
  if (section4) {
    observerIsFooter.observe(section4);
  }
});

const total = ref<number>(0); // 总条目数
const queryParams = reactive<INewsQuery>({
  //查询参数
  pageNum: 1,
  pageSize: 4, // 一页只展示4条新闻
  //  isAsc 和 orderByColumn 可以实现 按新闻年月 降序分页查询（最新的年份在前，以前的年份在后）
  isAsc: "descending", // 降序
  orderByColumn: "news_year_month",
});

const newsArr = ref<INewsRes[]>([]); // 新闻数据

function getList() {
  // 调用获取列表的接口
  listNews(queryParams).then((response: IResponseData<INewsRes>) => {
    newsArr.value = response.rows;
    total.value = response.total;
  });
}

function handleSizeChange(val: number) {
  queryParams.pageSize = val;
  queryParams.pageNum = 1;
  getList();
}

function handleCurrentChange(val: number) {
  queryParams.pageNum = val;
  getList();
}

getList(); // 页面加载调用getList方法

// 🐸🐸🐸🐸🐸🐸🐸🐸   定义适配函数
const reScreenSize = () => {
  let w = document.documentElement.clientWidth; // 获取设备的宽度
  let newFontSize = 10 * (w / 1920); // 计算新的字体大小
  newFontSize = Math.max(7.4, Math.min(newFontSize, 40));
  document.documentElement.style.fontSize = `${newFontSize}px`;
};

// 页面加载时执行一次适配
onMounted(() => {
  reScreenSize();
  window.addEventListener("resize", reScreenSize);
});

// 页面卸载时移除监听事件
onUnmounted(() => {
  window.removeEventListener("resize", reScreenSize);
});

return (_ctx: any,_cache: any) => {
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _directive_lazy_container = _resolveDirective("lazy-container")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(QrCode, { showQRCode: showQRCode.value }, null, 8, ["showQRCode"]),
    _createVNode(Footer, { showFooter: showFooter.value }, null, 8, ["showFooter"]),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newsArr.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "newsBox",
              key: item.newsId
            }, [
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("img", {
                  "data-src": _unref(apiUrl) + item.imageUrl,
                  alt: "公司新闻"
                }, null, 8, _hoisted_7)
              ])), [
                [_directive_lazy_container]
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(item.newsContent), 1),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("text", null, "发布日期：" + _toDisplayString(item.newsYearMonth), 1)
                ])
              ])
            ]))
          }), 128))
        ]),
        _createVNode(_component_el_pagination, {
          background: "",
          "current-page": queryParams.pageNum,
          "page-sizes": [6, 12, 24, 48],
          "page-size": queryParams.pageSize,
          total: total.value,
          layout: "total, prev, pager, next, jumper",
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange,
          class: "pagination"
        }, null, 8, ["current-page", "page-size", "total"])
      ])
    ]),
    _createElementVNode("section", _hoisted_11, [
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(awardImgs), (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.index,
            class: _normalizeClass(["container", item.index === 1 ? 'double-width' : 'single-width'])
          }, [
            _createElementVNode("div", _hoisted_14, [
              _withDirectives(_createElementVNode("img", _hoisted_15, null, 512), [
                [_directive_lazy, item.imgSrc]
              ])
            ]),
            _createElementVNode("span", _hoisted_16, _toDisplayString(item.content), 1)
          ], 2))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _hoisted_20,
        _createVNode(_component_el_row, {
          class: "cardContainer",
          gutter: 30
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bottomImg), (item) => {
              return (_openBlock(), _createBlock(_component_el_col, {
                key: item,
                xs: 12,
                sm: 12,
                md: 12,
                lg: 12
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _withDirectives(_createElementVNode("img", _hoisted_23, null, 512), [
                        [_directive_lazy, item.imgSrc]
                      ])
                    ]),
                    _createElementVNode("span", _hoisted_24, _toDisplayString(item.content), 1)
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})